// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"921ee67fd1fd6d931d4d","655":"a62b53d3d61a1c99545f"}[chunkId] + ".js";
};